export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";